import React from "react";
import "./Footer.css";

export default function Footer({ className = "" }) {
  return (
    <footer className={`olimpico-footer ${className}`}>
      <div className="olimpico-footer-content">
        <a
          href="https://www.olimpicoia.com"
          target="_blank"
          rel="noopener noreferrer"
          className="olimpico-footer-brand-link"
        >
          Olimpico IA
        </a>
        <span className="olimpico-footer-divider">|</span>
        <span className="olimpico-footer-item">
          <strong>Email:</strong>{" "}
          <a href="mailto:admin@olimpicoia.com" className="olimpico-footer-link">
            admin@olimpicoia.com
          </a>
        </span>
        <span className="olimpico-footer-divider">|</span>
        <span className="olimpico-footer-item">
          <strong>WhatsApp:</strong>{" "}
          <a
            href="https://wa.me/573208038075"
            target="_blank"
            rel="noopener noreferrer"
            className="olimpico-footer-link"
          >
            +57 3208038075
          </a>
        </span>
      </div>
    </footer>
  );
}
